












































import { Component, Vue } from "vue-property-decorator";
import CountDown from "@/components/CountDown.vue";
import { setBgPic } from "./JustBgPic";
@Component({
  components: {
    CountDown
  }
})
export default class HochzeitComp extends Vue {
  gwidth = "400";

  windoResize(): void {
    let wWidth: number = window.innerWidth;
    wWidth = Math.min(1700, Math.max(300, wWidth - 100));
    this.gwidth = wWidth.toString();
  }

  mounted(): void {
    setBgPic(document, true);
    // clrBgPic(document)
    this.windoResize();
    window.addEventListener("resize", this.windoResize);
  }
}
